import { CANVAS_WIDTH } from '@canvas-builder/constants'
import type { ComponentNode } from '@canvas-builder/types/canvas'

export const ACTUAL_CANVAS_WIDTH = CANVAS_WIDTH - 2 // 1200 - 2px border

export function calculateProportionalDimensions(
  originalWidth: number,
  originalHeight: number,
  targetWidth = ACTUAL_CANVAS_WIDTH,
) {
  const aspectRatio = originalHeight / originalWidth
  const newWidth = targetWidth
  const newHeight = Math.floor(targetWidth * aspectRatio)
  return { width: newWidth, height: newHeight }
}

export function getComponentPositionStyle(component: ComponentNode) {
  return {
    position: component.style?.position || 'relative',
    left: component.style?.left,
    top: component.style?.top,
    width: component.style?.width,
    height: component.style?.height,
    zIndex: component.style?.zIndex,
  }
}
